var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare01SolidStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5C2 3.34315 3.34315 2 5 2H11C11.5523 2 12 2.44772 12 3C12 3.55228 11.5523 4 11 4H5C4.44772 4 4 4.44772 4 5V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V16C20 15.4477 20.4477 15 21 15C21.5523 15 22 15.4477 22 16V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7296 3.30049C16.0186 3.18876 16.3465 3.26625 16.555 3.49553L21.555 8.99553C21.815 9.28159 21.815 9.71847 21.555 10.0045L16.555 15.5045C16.3465 15.7338 16.0186 15.8113 15.7296 15.6996C15.4405 15.5878 15.25 15.3099 15.25 15V12.25H12.5711C11.4439 12.25 10.3629 12.6978 9.56586 13.4948L7.53033 15.5304C7.31583 15.7449 6.99324 15.809 6.71299 15.6929C6.43273 15.5769 6.25 15.3034 6.25 15V12.5C6.25 9.32439 8.82436 6.75003 12 6.75003H15.25V4.00003C15.25 3.69018 15.4405 3.41222 15.7296 3.30049Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare01SolidStandard);
export default __webpack_public_path__ + "static/media/share-01-solid-standard.3b2264e23fa506144104594f276b5cc3.svg";
export { ForwardRef as ReactComponent };